/**
 * Prismatic Spark timeline — shared by the store (which holds the board
 * mutation until the VFX resolves) and the renderer (which plays the VFX).
 * Pure numbers, no pixi imports, so the store can depend on it.
 *
 *   t=0            draft overlay closes, chosen gears become held stand-ins
 *   LEAD           beat for the player's eye to find the board again
 *   + i*stagger    gear i starts to overheat (ripple across the chosen set)
 *   + HEAT         gear i shatters
 *   last shatter + COMMIT_PAD → store commits; unsupported gears drop
 */

/** Pause after the draft overlay closes before the first gear heats. */
export const PRISMATIC_LEAD_MS = 200;
/** Overheat + vibrate build-up per gear, ending in the shatter. */
export const PRISMATIC_HEAT_MS = 900;
/** Gap between successive gears starting to heat. */
const PRISMATIC_STAGGER_MS = 110;
/** Cap on first-to-last stagger so Mk. V (12 gears) doesn't drag. */
const PRISMATIC_MAX_SPREAD_MS = 550;
/** Commit lands just after the last shatter so drops read as its consequence. */
const PRISMATIC_COMMIT_PAD_MS = 80;

export function prismaticStaggerMs(count: number): number {
  if (count <= 1) return 0;
  return Math.min(PRISMATIC_STAGGER_MS, PRISMATIC_MAX_SPREAD_MS / (count - 1));
}

/** When gear `index` (of `count`) starts to overheat. */
export function prismaticHeatStartMs(index: number, count: number): number {
  return PRISMATIC_LEAD_MS + index * prismaticStaggerMs(count);
}

/** When the store should commit the post-Spark board. */
export function prismaticSparkTotalMs(count: number): number {
  if (count <= 0) return 0;
  return prismaticHeatStartMs(count - 1, count) + PRISMATIC_HEAT_MS + PRISMATIC_COMMIT_PAD_MS;
}
